import { render, staticRenderFns } from "./order-add.vue?vue&type=template&id=5dc57495&"
import script from "./order-add.vue?vue&type=script&lang=js&"
export * from "./order-add.vue?vue&type=script&lang=js&"
import style0 from "./order-add.vue?vue&type=style&index=0&id=5dc57495&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports